export const STUDENT_OFFLINE_MESSAGE =
  'Your device appears to have lost internet connection. Notify your teacher because data may be lost. Please wait while your device attempts to reconnect.';

export const TEACHER_OFFLINE_MESSAGE = 'Please check your internet connection and try again.';
